<template>
    <form v-loading="isLoading" @submit.prevent="send" :disabled="locked && !$hasPermission('affiliate_sales.lock')">
        <div class="form-row">
            <has-error :form="form" field="deal_id" class="d-block"/>
            <div class="form-group col-12">
                <label class="mb-0">Статус</label>
                <div class="custom-controls-stacked d-inline ml-3 justify-content-around">
                    <label class="custom-control custom-radio custom-control-inline mb-2">
                        <input :name="'status' + _uid" type="radio" class="custom-control-input" :value="true" v-model="status" :class="{ 'is-invalid': form.errors.has('status') }">
                        <span class="custom-control-label">Оформлен</span>
                    </label>
                    <label class="custom-control custom-radio custom-control-inline mb-2">
                        <input :name="'status' + _uid" type="radio" class="custom-control-input" :value="false" v-model="status" :class="{ 'is-invalid': form.errors.has('status') }">
                        <span class="custom-control-label">Отменен</span>
                    </label>
                </div>
                <has-error :form="form" field="status" class="d-block"/>
            </div>
            <div class="form-group col-12">
                <label class="mb-0" :for="'affiliate_program_id' + _uid">Продукт</label>
                <AffiliateProgramSelect :filter="{platform_id: sale && sale.platform_id ? sale.platform_id : null}" :id="'affiliate_program_id' + _uid" v-model="affiliate_program_id" style="width: 100%;" @change="setProduct" />
                <has-error :form="form" field="affiliate_program_id" class="d-block"/>
            </div>
            <div class="form-group col-12">
                <div class="form-inline" style="flex-wrap: nowrap;">
                    <label class="mr-2" :for="'document_number' + _uid">№</label>
                    <input style="max-width: 45%;" type="text" class="form-control" :id="'document_number' + _uid" v-model="document_number">

                    <label class="mx-2" :for="'document_date' + _uid">от</label>
                    <input type="date" class="form-control" style="flex-grow: 1" :id="'document_date' + _uid" v-model="document_date">

                    <has-error :form="form" field="document_number" class="d-block"/>
                    <has-error :form="form" field="document_date" class="d-block"/>
                </div>
            </div>
            <div class="form-group col-6">
                <label class="mb-0" :for="'sale_amount' + _uid">Сумма продажи</label>
                <input v-float type="text" class="form-control" :id="'sale_amount' + _uid" v-model="sale_amount" required>
                <has-error :form="form" field="sale_amount" class="d-block"/>
            </div>
            <div class="form-group col-6">
                <label class="mb-0" :for="'fee_amount' + _uid">КВ</label><i @click="calculateFee" class="fas fa-calculator cursor-pointer text-primary px-2"></i>
                <input v-float type="text" class="form-control" :id="'fee_amount' + _uid" v-model="fee_amount" required>
                <has-error :form="form" field="fee_percent" class="d-block"/>
            </div>
            <div class="form-group col-12">
                <label class="mb-0" :for="'comment' + _uid">Коментарий</label>
                <input type="text" class="form-control" :id="'comment' + _uid" v-model="comment">
                <has-error :form="form" field="comment" class="d-block"/>
            </div>
            <div class="form-group col-12">
                <label class="mb-0" :for="'manager_id' + _uid">Оформил</label>
                <el-select class="d-block" :id="'manager_id' + _uid" v-model="manager_id" size="mini" filterable v-loading="isLoadingManagers">
                    <el-option v-for="m in managers_select" :key="m.id" :label="m.name" :value="m.id"></el-option>
                </el-select>
                <has-error :form="form" field="manager_id" class="d-block"/>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-12">
                <button type="submit" v-if="mode === 'create' && $hasPermission('affiliate_sales.create')" class="btn btn-primary">Создать</button>
                <button type="submit" v-if="mode === 'edit' && $hasPermission('affiliate_sales.update')" class="btn btn-primary" :disabled="locked && !$hasPermission('affiliate_sales.lock')">Сохранить</button>

                <template v-if="mode === 'edit' && $hasPermission('affiliate_sales.lock')">
                    <button type="button" @click="lock" v-if="!locked" class="btn btn-light"><i class="fas fa-lock"></i> Заблокировать</button>
                    <button type="button" @click="unlock" v-if="locked" class="btn btn-dark"><i class="fas fa-lock"></i> Разблокировать</button>
                </template>
            </div>
        </div>
    </form>
</template>

<script>
import Form from "vform";
import AffiliateProgramSelect from "../affiliate_programs/AffiliateProgramSelect";
import PlatformHelper from "../../helpers/platform";
import AffiliateSalesApi from "../../api/affiliate_sales";

export default {
    name: "AffiliateSaleForm",
    components: {AffiliateProgramSelect},
    props: {
        sale: {
            type: Object,
            required: true,
        },
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['create', 'edit'].indexOf(value) !== -1
            }
        },
    },
    data: () => ({
        form: new Form({}),
        isLoading: false,
        isLoadingManagers: false,

        id: null,
        affiliate_program_id: null,
        deal_id: null,
        document_number: null,
        document_date: moment().format('YYYY-MM-DD'),
        sale_amount: 0,
        fee_amount: 0,
        comment: null,
        manager_id: null,
        status: true,
        locked: false,

        managers: [],
        product: null,
    }),
    mounted() {
        let self = this;
        this.loadObj(this.sale);
        this.fetchManagers();

        Echo.private(`affiliate_sale.${this.id}`)
            .listen('.affiliate_sale.updated', function (e) {
                self.loadObj(e.affiliate_sale);
            });
    },
    beforeDestroy() {
        Echo.leave(`affiliate_sale.${this.id}`);
    },
    computed: {
        managers_select() {
            let self = this;
            let items = [];

            this.managers.forEach(function (item) {
                if (item.is_active || (+self.manager_id === +item.id)) {
                    items.push({
                        id: item.id,
                        name: item.name,
                    });
                }
            })
            return items;
        }
    },
    methods: {
        loadObj(sale) {
            if (sale.id !== undefined) this.id = sale.id;
            if (sale.affiliate_program_id !== undefined) this.affiliate_program_id = sale.affiliate_program_id;
            if (sale.affiliate_program !== undefined) this.setProduct(sale.affiliate_program);
            if (sale.deal_id !== undefined) this.deal_id = sale.deal_id;
            if (sale.document_number !== undefined) this.document_number = sale.document_number;
            if (sale.document_date !== undefined) this.document_date = sale.document_date;
            if (sale.sale_amount !== undefined) this.sale_amount = sale.sale_amount / 100;
            if (sale.fee_amount !== undefined) this.fee_amount = sale.fee_amount / 100;
            if (sale.comment !== undefined) this.comment = sale.comment;
            if (sale.manager_id !== undefined) this.manager_id = sale.manager_id;
            if (sale.status !== undefined) this.status = !!sale.status;
            if (sale.locked !== undefined) this.locked = !!sale.locked;
        },
        setProduct(p) {
          this.product = p;
        },
        calculateFee() {
            if (this.product) {
                this.fee_amount = (parseFloat(("" + this.sale_amount).replaceAll(",",".")) * this.product.fee_percent / 100).toFixed(2);
            }
        },
        fetchManagers() {
            this.isLoadingManagers = true;
            axios.get('/api/users', {
                params: {
                    platform_id: [this.sale.platform_id],
                    has_permission_to: 'affiliate_sales.create',
                }
            })
                .then((res) => {
                    this.managers = res.data.data;
                    this.isLoadingManagers = false;
                })
        },
        makeForm() {
            this.form = new Form({
                id: this.id,
                affiliate_program_id: this.affiliate_program_id,
                deal_id: this.deal_id,
                document_number: this.document_number,
                document_date: this.document_date,
                sale_amount: this.sale_amount,
                fee_amount: this.fee_amount,
                comment: this.comment,
                manager_id: this.manager_id,
                status: this.status,
            });
        },
        send() {
            if (this.sale && this.sale.id) {
                this.update();
            } else {
                this.create();
            }
        },
        create(){
            let self = this;
            this.makeForm();
            this.isLoading = true;
            this.form.post('/api/affiliate_sales')
                .then(response => {
                    self.$emit('created', response.data);
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Создано',
                        duration: 2000,
                    });
                    self.$emit('saved', response.data);
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка при создании, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
        update(){
            let self = this;
            this.makeForm();
            this.isLoading = true;
            this.form.put('/api/affiliate_sales/' + this.sale.id)
                .then(response => {
                    self.$emit('updated', response.data);
                    self.isLoading = false;
                    self.$message.success({
                        message: 'Сохранено',
                        duration: 2000,
                    });
                    self.$emit('saved', response.data);
                })
                .catch(() => {
                    self.isLoading = false;
                    self.$message.error({
                        message: 'Ошибка, проверьте поля!',
                        duration: 2000,
                    });
                })
        },

        lock() {
            AffiliateSalesApi.lock([this.sale.id])
        },
        unlock() {
            AffiliateSalesApi.unlock([this.sale.id])
        }
    }
}
</script>

<style scoped>

</style>
